export default __webpack_public_path__ + "static/media/cocktails.f887eaac.png";